export const formatTaxNumber = ({ clientType, taxNumber, fallback = "" }) => {
    if (taxNumber == null || taxNumber === "") return fallback;

    const digits = String(taxNumber).replace(/\D/g, "").slice(0, 9);
    if (!digits) return fallback;

    const normalizedClientType = String(clientType ?? "").toUpperCase();

    if (normalizedClientType === "BUSINESS") {
        if (digits.length <= 2) return digits;
        return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    }

    if (normalizedClientType === "INDIVIDUAL") {
        if (digits.length <= 3) return digits;
        if (digits.length <= 5) {
            return `${digits.slice(0, 3)}-${digits.slice(3)}`;
        }
        return `${digits.slice(0, 3)}-${digits.slice(
            3,
            5,
        )}-${digits.slice(5)}`;
    }

    return digits;
};
